<template>
  <main class="fill-height">
    <overview></overview>
    <about-me></about-me>
    <work-experience></work-experience>
    <sample-projects></sample-projects>
    <all-projects></all-projects>
    <get-in-touch></get-in-touch>
  </main>
</template>

<script>
import AboutMe from '@/components/AboutMe'
import Overview from '../components/Overview.vue'
import WorkExperience from '../components/WorkExperience.vue'
import SampleProjects from '../components/SampleProjects.vue'
import AllProjects from '../components/AllProjects.vue'
import GetInTouch from '../components/GetInTouch.vue'

export default {
  name: 'Home',
  components: {
    AboutMe,
    Overview,
    WorkExperience,
    SampleProjects,
    AllProjects,
    GetInTouch
  },
  data () {
    return {}
  }
}
</script>
